const siteVars = {
    ajax_url: site_vars.ajax_url,
    nonce: site_vars.nonce,
    term_id: site_vars.term_id,
    taxonomy_name: site_vars.taxonomy_name,
    post_id: site_vars.post_id,
    term_id_product_json_files_path: site_vars.term_id_product_json_files_path,
    rewrite_url_related: site_vars.rewrite_url_related,
    rewrite_url_partner: site_vars.rewrite_url_partner,
    locale: site_vars.locale,
    currency_readable: site_vars.currency_readable,
    posts_per_page: parseInt(site_vars.posts_per_page),
    product_teaser_html_path: site_vars.product_teaser_html_path,
    wp_upload_url: site_vars.wp_upload_url,
};

export default siteVars;